import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/opt/app-root/src/website/app/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/app-root/src/website/variants/legacy/app/layouts/default.vue").then(m => m.default || m)),
  "footer-only": defineAsyncComponent(() => import("/opt/app-root/src/website/variants/legacy/app/layouts/footer-only.vue").then(m => m.default || m))
}